import React from 'react';

import { ImageProps } from './Image.types';
import ImageTokens from '../../generated/base/images';
import { ratioMap } from '../../generated/base/ratios';
import { buildQueryString, sizeToRadiusMap } from '../utils';

function Image(props: ImageProps) {
	const { className, imageToken, size, hasCornerRadius=false, altText = '', mode = 'light' } = props;
	const { url, ratio } = ImageTokens[imageToken];

	const dimensions = ratioMap[ratio][size];
	const thisClass = hasCornerRadius ? `${className} ${sizeToRadiusMap[size]}` : className
	const fullUrl = url + buildQueryString({ mode, size });

	return <img className={thisClass} src={fullUrl} alt={altText} style={dimensions} />;
}

export default Image;
